"use strict";

module.exports = {
	OBJECT_ID: /^[0-9a-fA-F]{24}$/,
	UUID: /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
	ACCESS_TOKEN: /^\d{13}.{64}$/,
	HOST: /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])$/,
	CONNECTABLE_DEVICE_ID: /^\d{15}$/,
	EXCEPTION_SOURCE: /^(TCP|SMS)$/,
	PROTOCOL_VERSION: /^PV[0-9]+$/,
	USERNAME: /^[a-zA-Z0-9_\-.@]{4,45}$/,
	PASSWORD: /^.{4,200}$/, // legalább 6 karakter
	EMAIL: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$/,
	PHONE_COUNTRY_CODE: /^\d{1,4}$/,
	PHONE_AREA_CODE: /^\d+$/,
	PHONE_NUMBER: /^\d+$/,
	LANGUAGE: /^\w{2}$/,
	PACKET_TYPE: /^(Packet|LogPacket|TransactionPacket|FirmwarePacket|ProgPacket|DebugPacket|InfoPacket|GeneralException|DataException|FailureException|ControlException|AlertException)$/,
	CONFIG_TYPE: /^(GsmConfig|LogAppConfig|InputConfig|CANConfig|J1708Config)$/,
	ICN_FEATURED_PROTOCOL_TYPE: /^(NONE|J1939|J1708)$/,
	EMBEDDED_DATA_OPERATION: /^(LAST|MAX|MIN|AVG|SUM|COUNT|INT)$/,
	EMBEDDED_DATA_FILTER_TYPE: /^(NONE|LOWPASS|SR_LIMIT|PULSE)$/,
	CAN_DATA_ENDIANNESS: /^(LITTLE_ENDIAN|BIG_ENDIAN)$/,
	EVENT_TYPE: /^(ScalarStateChange)$/,
	OPERATOR: /^(eq|ne|gt|gte|lt|lte|in|notin|between|notbetween)$/,
	NOTIFICATION_TYPE: /^(WEB|EMAIL|SMS)$/,
	DRIVER_ID: /^\d{5}$/,
	BOOLEAN: /^(0|1|false|true)$/,
	CLIENT_TYPE: /^(WEB)|(ANDROID)|(IOS)$/,
	UTC_TIME: /^[0-9]+$/,
	FILE_KEY: /^0x1[0-9a-fA-F]{4}$/,
	LOG_MODE: /^(IGNITION_BASED|MOVEMENT_BASED)$/,
	INPUT_SOURCE: /^(TRIVIAL|VIRTUAL)$/,
	HEX_STRING: /0x[0-f0-F]{8}/,
	
	unit: {
		DISTANCE_TRAVELED: /^(km|mi)$/,
		TIME_TRAVELED: /^(min|h|d|y)$/,
		VEHICLE_LENGTH: /^(cm|m|inch|ft|yd)$/,
		VEHICLE_SPEED: /^(km\/h|mph)$/,
		FUEL_QUANTITY: /^(l|gal)$/,
		ENGINE_OPERATING_TIME: /^(h|d|y)$/,
		CONSUMPTION: /^(l\/100km|mpg)$/,
		WEIGHT: /^(kg|lb)$/,
		RPM: /^rpm$/,
		RATIO: /^%$/,
		TEMPERATURE: /^(°C|°F|°K)$/,
		VOLTAGE: /^V$/
	},
	
	/* get COMMA_SEPARATED_EMAIL(){
		let e = this.EMAIL.source.replace('^', '').replace('$', '');
		return new RegExp(`^(${e})(,${e})*$`);
	},
	
	get SENDER() {
		let e = this.EMAIL.source.replace('^', '').replace('$', '');
		return new RegExp(`^((.+\\s+<${e}>)|(${e}))$`);
	} */
};


// WEBPACK FOOTER //
// ./~/vfu/pattern.js